module.exports = __webpack_public_path__ + "static/media/bolon-hub.c1ec296f.jpg";